<template>
  <div v-if="!!invoice.recipient">
    <b-dropdown variant="outline-branded" size="sm" :disabled="disabled">
      <template v-slot:button-content>
        <span v-if="!recipient_id">{{ trans('choose_a_' + type) }}</span>
        <span v-if="!!recipient_id">
          <i class="fa fa-fw fa-user"></i>
          {{ invoice.recipient.name }}
        </span>
      </template>
      <b-dropdown-item @click="onClick">
        <i v-if="!recipient_id" class="fa fa-fw fa-user-plus"></i>
        <i v-if="!!recipient_id" class="fa fa-fw fa-check"></i>
        <span>{{ invoice.recipient.name }}</span>
      </b-dropdown-item>
      <b-dropdown-text v-if="adminCanChangeClient">
        <b-button variant="outline-danger" v-b-modal.admin-choose-client-modal>
          <i class="fa fa-fw fa-user"></i>
          {{ trans('change_client') }}
        </b-button>
        <admin-choose-client-modal
          :organization="organization"
          :type="type"
          @chosen="onClientChosen"
        ></admin-choose-client-modal>
      </b-dropdown-text>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item @click="onClickDisconnect">
        <i class="fa fa-fw fa-door-open"></i>
        <span>{{ trans('disconnect') }}</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  import AdminChooseClientModal from './AdminChooseClientModal'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      value: Number, // recipient_id
      disabled: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'client',
      },
    },
    components: {
      AdminChooseClientModal,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        recipient_id: null,
      }
    },
    computed: {
      adminCanChangeClient() {
        return this.organization.auth_user &&
          this.organization.auth_user.can_connect_as_client //&& this.organization.has_memberships
      },
    },
    watch: {
      recipient_id() {
        this.$emit('input', this. recipient_id)
      },
      value() {
        this.recipient_id = this.value
      },
    },
    methods: {
      onClientChosen(client) {
        this.busy = false
        this.error = null
        let recipient_id = client.recipient_id || client.id
        let url = `/org/${this.organization.id}/client/impersonate/${recipient_id}`
        if (!!this.invoice) url = `/org/${this.organization.id}/cart/choose_client/${recipient_id}`
        axios.post(url)
        .then(response => {
          this.$emit('connected', response.data)
          this.recipient_id = recipient_id
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
      onClick() {
        this.recipient_id = !this.recipient_id ? this.invoice.recipient.id : null
      },
      onClickDisconnect() {
        this.$bvModal.msgBoxConfirm(trans('confirm_disconnect_forget_cart'), {
          title: trans('disconnect'),
          okTitle: trans('yes'),
          okVariant: 'danger',
          cancelTitle: trans('cancel'),
        })
        .then(confirmed => {
          if (!confirmed) return
          const url = `/org/${this.organization.id}/cart/disconnect`
          axios.post(url)
          .then(response => {
            this.$bvToast.toast(response.data.message, {
              title: trans('success'),
              variant: 'success',
              solid: true,
            })
            this.recipient_id = null
            this.$emit('disconnected', response.data)
          })
          .catch(error => {
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        })
      },
    },
    mounted() {
      window.chooseClient = this
    },
  }
</script>